// frontend/src/components/Captcha.tsx
import React, { useState, useEffect, useCallback, useMemo } from "react";
import AuthService from "../../services/AuthService";
import { Alert, Box, Paper, TextField } from "@mui/material";
import useTranslation from "../../hooks/useTranslation";

interface CaptchaProps {
  onChange: ({
    captchaId,
    captchaCode,
  }: {
    captchaId: string;
    captchaCode: string;
  }) => void;
}

const Captcha: React.FC<CaptchaProps> = ({ onChange }) => {
  const [captchaId, setCaptchaId] = useState<string>("");
  const [captchaImage, setCaptchaImage] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [userInput, setUserInput] = useState<string>("");
  const [error, setError] = useState<string>("");
  const authService = useMemo(() => new AuthService(), []);
  const { t } = useTranslation();

  useEffect(() => {
    if (captchaId || isLoading) {
      return;
    }
    try {
      console.log("Fetching CAPTCHA...");
      setIsLoading(true);
      authService
        .fetchCaptcha()
        .then((response) => {
          setCaptchaId(response.captchaId);
          setCaptchaImage(response.image);
          setError("");
        })
        .finally(() => {
          setIsLoading(false);
        });
    } catch (err) {
      setError(err instanceof Error ? err.message : t("captchaFetchError"));
    }
  }, [authService, captchaId, isLoading, t]);

  useEffect(() => {
    onChange({ captchaId, captchaCode: userInput });
  }, [userInput, captchaId, onChange]);

  return (
    <Paper
      elevation={0}
      sx={{
        marginTop: "48px",
        marginBottom: "32px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        borderTopLeftRadius: "6px",
        borderTopRightRadius: "6px",
        overflow: "hidden",
        border: "1px solid #eee",
      }}
    >
      {captchaImage && (
        <Box sx={{ backgroundColor: "#eee", width: "100%" }}>
          <img src={captchaImage} alt="CAPTCHA" width="120px" />
        </Box>
      )}
      {error && <Alert severity={"error"}>{t("captchaError")}</Alert>}
      <TextField
        type="number"
        value={userInput}
        onChange={(e) => setUserInput(e.target.value)}
        placeholder={t("enterCaptcha")}
      />
    </Paper>
  );
};

export default Captcha;
